import { Directive } from '@angular/core';

/**
 * Directive for displaying a custom text on the dropdown when an item was selected.
 * This allows for consumers to specify a custom toggle label but it has no code,
 * it only acts as a content projection slot for the dropdown component
 *
 * @example
 * <td-wb-dropdown>
      <td-wb-dropdown-toggle>
        <span [innerText]="'Custom:'+getCustomLabel()"></span>
      </td-wb-dropdown-toggle>
      @for (securityType of securityTypes; track securityType) {
       <td-wb-dropdown-item [value]="securityType">
        <span>{{ securityType }}</span>
       </td-wb-dropdown-item>
      }
    </td-wb-dropdown>
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'td-wb-dropdown-toggle'
})
export class DropdownToggleDirective {
}
